import {action, computed, Highlighter, observer, React, useAsObservableSource} from '@api'
import {Check} from '@material-ui/icons'
import {useVipLocalStore, VipLocalStore, ChangeLogFilterFieldConfig, IChangeLogFieldConfig} from '@modules'
import {ExcludeEye} from '@stores/ui'
import {PrimaryIconButton} from 'centric-ui-components'
import * as css from './ContentTitleBarItemField.css'
import {ICatalogFieldConfig, StoresInstance, WorkspaceChangeLogAdditionalConfigType} from '@stores'

interface IContentTitleBarItemFieldProps {
  field: IChangeLogFieldConfig & WorkspaceChangeLogAdditionalConfigType
  workspace?: string
  onSelectMenuItem?: Function
  onExcludeMenuItem?: Function
  selected?: any
  searchText?: string
  isSelected?: boolean
  selectedField?: ChangeLogFilterFieldConfig
  hasExclude?: boolean
  isExcluded?: boolean
  renderTo?: 'applied' | 'all'
  label?: string
}

class ContentTitleBarItemFieldStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<IContentTitleBarItemFieldProps, 'className'>) {
    super(stores)
  }

  get field(): string {
    const {props: {field: {field, def}}} = this
    return field ?? def?.type
  }

  get def(): IChangeLogFieldConfig {
    const {props: {field}} = this
    return field
  }

  @computed get key(): string {
    const {field, def: {workspace}} = this
    return workspace ? `${workspace}.${field}` : field
  }

  @computed get isSelected() {
    const {props: {selected, isSelected}, field, key} = this
    return isSelected ?? selected.some(s => (s.type === field || s.field === field || s.type === key)) ?? false
  }

  @computed get isExcluded() {
    const {props: {isExcluded}} = this
    return isExcluded ?? false
  }

  @computed get showExclude() {
    const {props: {hasExclude}} = this
    return hasExclude
  }

  @computed get label() {
    const {catalog: {labelForField}, props: {field, label}} = this
    return label ?? labelForField(field)
  }

  @computed get workspaceLabel() {
    const {props: {workspace}} = this
    return workspace
  }

  @action onSelectMenuItem = () => {
    const {props: {onSelectMenuItem, selectedField, isExcluded}, key, def} = this
    if (def.esNested || isExcluded) return

    if (onSelectMenuItem) onSelectMenuItem(key, def, selectedField)
  }

  @action onExcludeMenuItem = () => {
    const {props: {onExcludeMenuItem}, key, def} = this
    if (def.esNested) return

    if (onExcludeMenuItem) onExcludeMenuItem(key, def)
  }

  @computed get searchText() {
    const {props} = this
    return props.searchText
  }

}

export const ContentTitleBarItemFieldStoreContext = React.createContext<ContentTitleBarItemFieldStore>(null)
export const useContentTitleBarItemFieldStore = () => React.useContext(ContentTitleBarItemFieldStoreContext)

export const ContentTitleBarItemField = observer<IContentTitleBarItemFieldProps>(function Content(props) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore(ws => new ContentTitleBarItemFieldStore(ws, obsProps)),
    {onSelectMenuItem, showExclude, onExcludeMenuItem, isSelected, label, searchText, workspaceLabel, isExcluded, props: {renderTo}} = store

  return (
    <div className={css.root}>
      <div className={css.left} onClick={onSelectMenuItem} data-render-to={renderTo}>
        <Check data-selected={isSelected}/>
        <div data-type={'menu-text'} data-selected={isSelected} data-excluded={isExcluded}>
          <Highlighter textToHighlight={label} searchWords={[searchText]}/>
        </div>
      </div>
      {workspaceLabel && <div className={css.right}>
		  <div data-type={'menu-workspace'}>{workspaceLabel}</div>
	  </div>}
      {showExclude === true && isSelected === false && <div className={css.right}>
		  <PrimaryIconButton
			  data-type-item={'excluded'}
			  data-excluded={isExcluded}
			  icon={<ExcludeEye/>}
			  onClick={onExcludeMenuItem}
		  />
	  </div>}
    </div>
  )
})


// WEBPACK FOOTER //
// ./src/modules/titleBarItem/ContentTitleBarItemField.tsx